export const CENTI_SUPPORT = {
  phoneDisplay: "+234 703 912 8339",
  phoneDial: "+2347039128339",
  whatsappUrl: "https://wa.link/rxphgx",
  email: "support@centihq.com",
} as const;
